import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class QuestionCategoryRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    return true;
  }
}